export type Timeout = ReturnType<typeof setTimeout>;

export const deepMerge = <T extends object>(source: object, target: T): T => {
  for(const [key, value] of Object.entries(source)) {
    if(typeof value !== "object" || value === null || value instanceof Array) (target as { [key: string]: unknown })[key] = value;
    else {
      const val = (target as { [key: string]: unknown })[key];

      if(typeof val === "object" && val !== null) deepMerge(value as object, val);
      else (target as { [key: string]: unknown })[key] = value;
    }
  }

  return target;
};

export const urls = {
  devMatch: "/match",
  match:    "/match/:matchId",
  settings: "/settings"
} as const;
